// =======================
// == Animations/Report.js ==
// =======================
/*
  All of the animations for report.js
*/

import Animator from './animator';
const { call, animations } = new Animator();
const animate = target => call(target, animations.downAndFadeOut);
export default animate;
